import { createFetchWithRetry } from "./http/fetchWithRetryPolicy";

/**
 * Default retrying fetch for Supabase and legacy call sites (same policy as apiClient when `retry: true`).
 */
export const fetchWithRetry = createFetchWithRetry();
